<template>
    <div id="indexChartPie"></div>
</template>

<script>
 import * as echarts from "echarts";
export default {
    name: 'index-pie-chart',
    props: {
        collapsed: {
            type: Boolean,
        },
        rateReviewData: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data () {
    return {
    }
    },
    mounted () {
        var _this=this;
        window.addEventListener("resize", ()=>{
            if(_this.chartLine!=null){
                _this.chartLine.resize();
            }
        })
        this.drawLineChart();
    },
    watch: {
        'rateReviewData': {
            handler (val) {
                this.drawLineChart();
            },
            deep: true
        },
        'collapsed': {
            handler (val) {
                if(this.chartLine!=null){
                    this.chartLine.resize();
                }
            },
            deep: true
        },
    },
    methods: {
        drawLineChart:function() {
            if(this.rateReviewData.length==0){
                return;
            }
            this.chartLine = echarts.init(document.getElementById('indexChartPie'));

            let option = {
                color:["#999",'red',"green"],
                title: {
                    left: 'center'
                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'vertical',
                    x: '10%',
                    y: '9%'
                },
                series: [
                    {
                        label: {
                            show: false,
                        //     formatter: '{d}% '
                        },
                        name: '',
                        type: 'pie',
                        radius: ['60%', '80%'],
                        data:this.rateReviewData
                    }
                ]
            }
            this.chartLine.setOption(option,true)
        },
    }
}
</script>

<style lang="scss">
#indexChartPie{
    width: 100%;
    height: calc(100% - 60px);
}
</style>



// WEBPACK FOOTER //
// IndexPieChart.vue?48049f2e